import axios from 'axios';
import * as Cookie from 'tiny-cookie';

export const createUserBookmark = (
  teamId: string,
  projectId: number,
  userId: number,
) => {
  return axios.post<{ id: number }>(
    `/api/v3/teamplan/${teamId}/projects/${projectId}/bookmarks/user`,
    {
      user_id: userId,
    },
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};

export const destroyUserBookmark = (
  teamId: string,
  projectId: number,
  userBookmarkId: number,
) => {
  return axios.delete<{}>(
    `/api/v3/teamplan/${teamId}/projects/${projectId}/bookmarks/user/${userBookmarkId}`,
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};

export const setUserBookmarkMemo = (
  teamId: string,
  projectId: number,
  userBookmarkId: number,
  memo: string,
) => {
  return axios.patch<{}>(
    `/api/v3/teamplan/${teamId}/projects/${projectId}/bookmarks/user/${userBookmarkId}/set_memo`,
    { memo },
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};

export const createTopicBookmark = (
  teamId: string,
  projectId: number,
  topicId: number,
) => {
  return axios.post<{ id: number }>(
    `/api/v3/teamplan/${teamId}/projects/${projectId}/bookmarks/topic`,
    {
      topic_id: topicId,
    },
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};

export const destroyTopicBookmark = (
  teamId: string,
  projectId: number,
  topicBookmarkId: number,
) => {
  return axios.delete<{}>(
    `/api/v3/teamplan/${teamId}/projects/${projectId}/bookmarks/topic/${topicBookmarkId}`,
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};

export const setTopicBookmarkMemo = (
  teamId: string,
  projectId: number,
  topicBookmarkId: number,
  memo: string,
) => {
  return axios.patch<{}>(
    `/api/v3/teamplan/${teamId}/projects/${projectId}/bookmarks/topic/${topicBookmarkId}/set_memo`,
    { memo },
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};
